export default "__VITE_ASSET__CcNwwk9c__"